import * as React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PageHeader() {
  return <section id="page-header" className="relative flex min-h-[45vh] items-center overflow-hidden bg-gradient-to-br from-[var(--color-logo)] to-[var(--color-secondary)] py-16 md:py-24">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_grid_pattern.png)] bg-repeat opacity-5 mix-blend-overlay" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {}
          <div className="flex flex-col items-start">
            <Breadcrumb className="mb-6">
              <BreadcrumbList className="text-primary/80 sm:gap-2">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="hover:text-primary">
                    <Link to="/">Home</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-primary/60" />
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="hover:text-primary">
                    <Link to="/IndustriesPage">Industries</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-primary/60" />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-medium text-primary">
                    Specifying Engineers
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>

            <span className="mb-4 block text-sm font-semibold tracking-wider text-primary uppercase">
              For Specifying Engineers
            </span>

            <h1 className="font-default mb-6 text-4xl font-bold leading-tight text-white md:text-5xl lg:text-6xl">
              Nameplate & Labeling Supplier for Specifying Engineers
            </h1>

            <p className="mb-8 max-w-2xl text-lg leading-relaxed text-gray-300 md:text-xl">
              Evermark Industrial Solutions gives specifying engineers what they
              need to specify identification correctly and by name — CSI 3-part
              specifications, material data sheets, standards references, and
              basis-of-design language for nameplates, legend plates, arc flash
              labels, and MIL-SPEC marking. Request a submittal package for your
              spec section.
            </p>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/ContactPage">
                  Request a Submittal Package
                  <ChevronRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary bg-transparent text-primary hover:bg-primary/10 hover:text-primary">
                
              </Button>
            </div>
          </div>

          {}
          <div className="relative hidden lg:block">
            <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl">
              <div className="absolute inset-0 bg-gradient-to-tr from-[var(--color-logo)]/40 to-transparent mix-blend-multiply z-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engineer_reviewing_spec_submittal.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engineer_reviewing_spec_submittal.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engineer_reviewing_spec_submittal.png-wvc-sizes" alt="Nameplate and labeling supplier for specifying engineers — Evermark Industrial Solutions submittal documentation" className="aspect-[4/3] h-full w-full object-cover" loading="lazy" decoding="async" />
            </div>
            {}
            <div className="absolute -bottom-4 -left-4 -z-10 h-24 w-24 rounded-lg border-2 border-primary/30 bg-transparent" />
          </div>
        </div>
      </div>
    </section>;
}